import React, { useEffect, useState } from 'react'
import { Coordinates } from '../../../../../types/address'
import { fetchPlaces } from '../../../../../services/api/address';
import LocationArrowIcon from '../../../../icons/LocationArrowIcon';

const NearbyStores: React.FC<{ query: string, type?: string, onChange?: (placeId: string | null) => void }> = ({ query, onChange }) => {

    const [coordinates, setCoordinates] = useState<Coordinates | null>(null);
    const [loading, setLoading] = useState(true);
    const [stores, setStores] = useState<any[]>([]);
    const [selectedPlaceId, setSelectedPlaceId] = useState<string | null>(null);

    const fetchGeolocation = async () => {
        navigator.geolocation.getCurrentPosition(
            (pos) => setCoordinates({ latitude: pos.coords.latitude, longitude: pos.coords.longitude }),
            (err) => {
                console.error(err)
            }
        )
    }

    useEffect(() => {
        fetchGeolocation();
    }, [])

    const fetchStores = async () => {
        if (!coordinates || !query) return
        try {
            setLoading(true);
            const places = await fetchPlaces(query, coordinates);
            if (Array.isArray(places)) {
                setStores(places);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (coordinates) fetchStores();
    }, [coordinates])

    useEffect(() => {
        onChange?.(selectedPlaceId);
    }, [selectedPlaceId])

    return (
        <div className='nearby-stores'>
            {
                coordinates ? (
                    <div className='h-100'>
                        {
                            loading ? (
                                <div className='d-flex justify-content-center align-items-center h-100 flex-column gap-2'>
                                    <div className="spinner-border text-primary"></div>
                                    <span>Loading...</span>
                                </div>
                            ) : (
                                <div className='h-100'>
                                    {
                                        (stores.length > 0) ? (
                                            <div className="location-list mt-0">
                                                {
                                                    stores.map((store, i) => {
                                                        return (
                                                            <div className="location-list-item cursor-pointer" key={i} onClick={() => setSelectedPlaceId(store.placePrediction?.placeId ?? null)} >
                                                                <div className="location-list-item-top">
                                                                    <div className="gig-selection-checkbox-wrapper">
                                                                        <input
                                                                            type="checkbox"
                                                                            className="form-check-input gig-selection-check-input radio-check"
                                                                            checked={store.placePrediction?.placeId === selectedPlaceId}
                                                                            onChange={() => setSelectedPlaceId(store.placePrediction?.placeId ?? null)}
                                                                        />
                                                                    </div>
                                                                    {/* <LocationArrowIcon /> */}
                                                                    <span className="location-list-item-title">
                                                                        {store.placePrediction?.structuredFormat?.mainText?.text}
                                                                    </span>
                                                                </div>
                                                                <span className="location-list-item-address">
                                                                    {store.placePrediction?.structuredFormat?.secondaryText?.text}
                                                                </span>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        ) : (
                                            <div className="d-flex justify-content-center align-items-center h-100 flex-column gap-2">
                                                <span>We couldn't find a store near you!</span>
                                            </div>
                                        )
                                    }
                                </div>
                            )
                        }
                    </div>
                ) : (
                    <div className='d-flex flex-column align-items-center justify-content-center gap-3 h-100'>
                        <span>
                            Please allow location access to view nearby stores!
                        </span>
                        <button onClick={fetchGeolocation} className="theme-btn theme-btn-sm theme-btn-primary">Allow Access</button>
                    </div>
                )
            }
        </div>
    )
}

export default NearbyStores